import React, { useState } from 'react';
import { Alert, Form, Input, Button } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthLayout from '../components/AuthLayout';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const onFinish = async (values) => {
    setLoading(true);
    setError('');
    try {
      const result = await login(values);
      if (result.success) {
        const from = location.state?.from;
        navigate(from?.startsWith('/app/') ? from : '/app/orders', {
          replace: true,
        });
      } else setError(result.message || '登录失败，请核对用户名和密码。');
    } catch (failure) {
      setError(failure.message || '暂时无法登录，请稍后重试。');
    } finally {
      setLoading(false);
    }
  };
  return (
    <AuthLayout
      title="登录工作台"
      description="欢迎回来，继续处理你的采购订单。"
    >
      {error && (
        <Alert className="inline-error" type="error" showIcon message={error} />
      )}
      <Form
        layout="vertical"
        onFinish={onFinish}
        requiredMark={false}
        disabled={loading}
      >
        <Form.Item
          label="用户名"
          name="username"
          rules={[
            { required: true, whitespace: true, message: '请输入用户名' },
          ]}
        >
          <Input size="large" autoComplete="username" />
        </Form.Item>
        <Form.Item
          label="密码"
          name="password"
          rules={[{ required: true, message: '请输入密码' }]}
        >
          <Input.Password size="large" autoComplete="current-password" />
        </Form.Item>
        <Button
          className="auth-submit"
          type="primary"
          htmlType="submit"
          block
          loading={loading}
        >
          登录
        </Button>
      </Form>
      <p className="auth-switch">
        已收到邀请码？ <Link to="/register">受邀开通账号</Link>
      </p>
    </AuthLayout>
  );
};
export default Login;
